const ns = "GUEST_LISTS";
export const RECEIVE = `${ns}_RECEIVE`;
export const RECEIVE_GROUP_DATA = `${ns}_RECEIVE_GROUP_DATA`;
export const REQUEST = `${ns}_REQUEST`;
